import GetProjectGroupTree from '@/connection/projects/get-project-group-tree';
import { serializeError } from '@/store/utils/serialize-error';
import { EventGroupTreeEntry } from '@/types/projects.types';
import { ProjectsReducerCreator } from '../types';

const loadProjectGroupTreeReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const groupTree = await GetProjectGroupTree(channel);
        return groupTree;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      pending: (state) => {
        state.gettingGroupTree = true;
      },
      fulfilled: (state, action) => {
        state.projectGroupTree = action.payload.tree;
        state.projectGroupTreeNameMap = action.payload.nameMap;
      },
      rejected: (state) => {
        state.projectGroupTree = { ungrouped: { events: {} } } as EventGroupTreeEntry;
        state.projectGroupTreeNameMap = {};
      },
      settled: (state) => {
        state.gettingGroupTree = false;
      },
    }
  );
};

export default loadProjectGroupTreeReducer;
